export default __webpack_public_path__ + "static/media/bg.472d2b3e.png";